module.exports = __webpack_public_path__ + "static/media/ios-cloud.2de53d7b.svg";